import { useContext } from 'react'
import { AppContext } from 'App'
import Autocomplete from 'react-google-autocomplete'
import { IEventData, IErrors } from 'interface/calendar'
import { IAddress } from 'interface/address'
import { AptiveIcon } from '@aptive-env/storybook'

interface IEventLocationInputProps {
  initAddress: string;
  setEventData: React.Dispatch<React.SetStateAction<IEventData>>;
  setErrors: React.Dispatch<React.SetStateAction<IErrors>>;
}

export const EventLocationInput: React.FC<IEventLocationInputProps> = ({
  initAddress,
  setEventData,
  setErrors,
}) => {
  const { isGoogleMapAPILoaded } = useContext(AppContext)

  return (
    <div>
      <p className="font-inter text-sm font-normal leading-4 text-dark-gray-100">
        Location
      </p>
      <div className="flex mt-1 border h-[38px] px-[13px] py-[9px] rounded-lg">
        <AptiveIcon
          icon="locationMarker"
          className="w-5 h-5 stroke-[#9CA3AF] fill-none cursor-pointer"
        />
        <div className="ml-3 flex flex-col grow gap-5">
          {isGoogleMapAPILoaded && (
            <Autocomplete
              // @ts-ignore
              placeholder="Enter location"
              className="w-full outline-none text-sm leading-4 placeholder-[#A9A9A9] text-[#111827]"
              apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''}
              options={{
                types: [],
                componentRestrictions: { country: 'us' },
              }}
              defaultValue={initAddress}
              onPlaceSelected={(place) => {
                const tempLocationData: IAddress = {
                  address: place.formatted_address || '',
                  city: '',
                  state: '',
                  zip: '',
                }
                place.address_components?.forEach((address_component) => {
                  if (address_component.types.includes('locality'))
                    tempLocationData.city = address_component.short_name
                  if (
                    address_component.types.includes(
                      'administrative_area_level_1'
                    )
                  )
                    tempLocationData.state = address_component.short_name
                  if (address_component.types.includes('postal_code'))
                    tempLocationData.zip = address_component.short_name
                })
                setEventData((prevData) => ({
                  ...prevData,
                  locationData: tempLocationData,
                }))

                if (place.geometry?.location) {
                  const placeLat = place.geometry.location.lat()
                  const placeLng = place.geometry.location.lng()
                  setEventData((prevData) => ({
                    ...prevData,
                    geoLocation: { lat: placeLat, lng: placeLng },
                  }))
                }

                const missingLocationData: string[] = []
                Object.keys(tempLocationData).forEach((key: string) => {
                  if (tempLocationData[key] === '')
                    missingLocationData.push(key)
                })
                if (missingLocationData.length) {
                  const errorMsg =
                    'Your location doesn\'t contain ' +
                    missingLocationData.join(', ') +
                    '.'
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    address: errorMsg,
                  }))
                }
              }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
